import { Component, EventEmitter, Input, Output } from '@angular/core';
import { hexToRgb } from '@shared/utils/hex-to-rgb.helper';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Tag } from '@models/common/tag';

@Component({
  selector: 'app-tag',
  standalone: true,
  imports: [
  ],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss'
})
export class TagComponent implements ICellRendererAngularComp {
  @Input() tag = new Tag();

  @Output() clickTag = new EventEmitter<Tag>();

  onClickTag(): void {
    this.clickTag.emit(this.tag);
  }

  agInit(params: ICellRendererParams): void {
    this.tag = new Tag(params?.data || {});
  }

  refresh(params: ICellRendererParams): boolean {
    this.tag = new Tag(params?.data || {});
    return true;
  }

  get customColor(): string {
    return this.tag.customColor || '#000';
  }

  get backgroundColor(): string {
    return hexToRgb(this.tag.customColor, 0.1);
  }
}
